import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';
import { fetchJSON } from '@hc-frontend/core-utils-net';

import type { OverrideExperimentRepository } from '../../domain';

export function overrideExperimentAdapterFactory({
  amplitudeApiKey,
  amplitudeIdentifyUrl,
}: {
  amplitudeApiKey: string;
  amplitudeIdentifyUrl: string;
}): OverrideExperimentRepository {
  return async ({ experimentName, experimentVariant, domainUserId }) => {
    const identification = {
      user_id: domainUserId,
      user_properties: {
        $set: {
          [`[Experiment] ${experimentName}`]: experimentVariant,
        },
      },
    };

    try {
      await fetchJSON(amplitudeIdentifyUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: {
          identification: JSON.stringify(identification),
          api_key: amplitudeApiKey,
        },
      });

      return createSuccessOperationResult(undefined);
    } catch (error) {
      return createErrorOperationResult({
        errors: [
          { rootCause: error as Error, code: 'failedToOverrideExperiment' },
        ],
      });
    }
  };
}
